var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#EE4F4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8268 4.17317C12.0577 4.40405 12.0577 4.77842 11.8268 5.0093L8.83614 8.00001L11.8268 10.9907C12.0577 11.2216 12.0577 11.5959 11.8268 11.8268C11.5959 12.0577 11.2216 12.0577 10.9907 11.8268L8 8.83614L5.0093 11.8268C4.77842 12.0577 4.40406 12.0577 4.17318 11.8268C3.94229 11.5959 3.94229 11.2216 4.17318 10.9907L7.16386 8L4.17317 5.00931C3.94228 4.77843 3.94228 4.40406 4.17317 4.17318C4.40405 3.94229 4.77842 3.94229 5.0093 4.17318L8 7.16388L10.9907 4.17317C11.2216 3.94228 11.5959 3.94228 11.8268 4.17317Z",
    fill: "#F2F3EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveSm);
export default __webpack_public_path__ + "static/media/Remove-sm.b6b6d30cbcd9a112ded67d03af1957cf.svg";
export { ForwardRef as ReactComponent };